export function isResponse401(res: any) {
  if (res == null) return false;

  if (res.status === 401) return true;

  // Gestiamo il caso "Header mancante" come 401
  if (
    res.status === 500 &&
    res.data?.titolo?.includes(
      `Required request header 'Authorization' for method parameter type String is not present`,
    )
  ) {
    return true;
  }

  return false;
}
